export default __webpack_public_path__ + "static/font-d12953eae6663b196c1398e681c41c1e.woff2";